import React from 'react'
import PropTypes from 'prop-types'
import { Main } from './styles'

export const DefaultButton = (props) => {
  const { label, secondary, id, onClick, variant, className, type, ...otherProps } = props
  return (
    <Main
      id={id}
      type={type || 'button'}
      secondary={secondary}
      onClick={onClick}
      className={className}
      {...otherProps}
    >
      {label}
    </Main>
  )
}

DefaultButton.propTypes = {
  label: PropTypes.any,
  secondary: PropTypes.bool,
}

DefaultButton.defaultProps = {
  secondary: false,
}
